import { ReactComponent as AccountSettingsIcon } from 'assets/account-settings.svg';
import { ReactComponent as NotificationSettingsIcon } from 'assets/notification-settings.svg';
import { ReactComponent as SecurityIcon } from 'assets/LockIcon.svg';
import { ReactComponent as TermsConditionsIcon } from 'assets/terms-conditions.svg';
import { ReactComponent as PrivacyPolicyIcon } from 'assets/privacy-policy.svg';
import { ReactComponent as SignOutIcon } from 'assets/sign-out.svg';

/**
 * MobileSettingsConfig - Configuration arrays for mobile settings pages
 * Centralized configuration to improve DRY principles and maintainability
 */

// Notification settings types
export interface NotificationSettings {
  sms: boolean;
  email: boolean;
}

export interface NotificationPreferences {
  allNotifications: NotificationSettings;
  missingReceipts: NotificationSettings;
  missingCodes: NotificationSettings;
  newTransactions: NotificationSettings;
}

// Notification settings configuration
export const NOTIFICATION_CONFIG = [
  {
    key: 'allNotifications' as const,
    labelKey: 'mobileNotificationSettingsAllNotifications',
  },
  {
    key: 'missingReceipts' as const,
    labelKey: 'mobileNotificationSettingsMissingReceiptsAlert',
  },
  {
    key: 'missingCodes' as const,
    labelKey: 'mobileNotificationSettingsMissingCodesAlert',
  },
  {
    key: 'newTransactions' as const,
    labelKey: 'mobileNotificationSettingsNewTransactions',
  },
] as const;

// Menu configuration
export const MENU_CONFIG = [
  {
    id: 'account-settings',
    labelKey: 'mobileMenuProfile',
    icon: AccountSettingsIcon,
    path: '/settings/account',
  },
  {
    id: 'notification-settings',
    labelKey: 'mobileMenuNotificationSettings',
    icon: NotificationSettingsIcon,
    path: '/settings/notifications',
  },
  {
    id: 'security',
    labelKey: 'security',
    icon: SecurityIcon,
    path: '/settings/security',
  },
  {
    id: 'terms-conditions',
    labelKey: 'mobileMenuTermsConditions',
    icon: TermsConditionsIcon,
    path: '/settings/terms',
  },
  {
    id: 'privacy-policy',
    labelKey: 'mobileMenuPrivacyPolicy',
    icon: PrivacyPolicyIcon,
    path: '/settings/privacy',
  },
  {
    id: 'sign-out',
    labelKey: 'mobileMenuSignOut',
    icon: SignOutIcon,
    action: 'handleSignOut',
  },
] as const;

// Privacy policy section keys
export const PRIVACY_POLICY_SECTION_KEYS = [
  'introduction',
  'whoWeAre',
  'scope',
  'informationCollect',
  'howWeUse',
  'legalBases',
  'sharingData',
  'cookiesTracking',
  'dataSecurity',
  'internationalTransfers',
  'yourRights',
  'updates',
  'contact',
  'additional',
] as const;

// Default notification preferences
export const DEFAULT_NOTIFICATION_PREFERENCES = {
  allNotifications: { sms: false, email: false },
  missingReceipts: { sms: true, email: true },
  missingCodes: { sms: true, email: true },
  newTransactions: { sms: true, email: false },
} as const;

export type NotificationConfigKey = (typeof NOTIFICATION_CONFIG)[number]['key'];
export type MenuConfigItem = (typeof MENU_CONFIG)[number];
export type PrivacyPolicySectionKey = (typeof PRIVACY_POLICY_SECTION_KEYS)[number];
